/**
 * @public
 */
export enum IdesMicroWorkerMessages {
	CheckComplete = 'CheckComplete',
	CheckFailed = 'CheckFailed',
	Initialise = 'Initialise',
	Terminate = 'Terminate',
	LoadingResources = 'LoadingResources',
	PerformQualityCheck = 'PerformQualityCheck',
	ReadyToProcess = 'ReadyToProcess',
	Error = 'Error',
}
